'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.mcReady = mcReady;
exports.show = show;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _server = require('react-dom/server');

var _server2 = _interopRequireDefault(_server);

var _modal = require('modal');

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MCLoaded = false;

function mcReady() {
	window.$mcj = window.jQuery.noConflict(true);
	window.fnames = ['EMAIL', 'FNAME', 'LNAME', 'MMERGE3', 'MMERGE4'];
	window.ftypes = ['email', 'text', 'text', 'text', 'text'];
	MCLoaded = true;
}

var MCHead = '\n\t<script type=\'text/javascript\' src=\'//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js\' onload=\'require("mailchimp-signup").mcReady();\' async></script>\n';

var MailchimpSignupForm = function (_Modal) {
	_inherits(MailchimpSignupForm, _Modal);

	_createClass(MailchimpSignupForm, null, [{
		key: 'load',
		value: function load() {
			if (!MCLoaded) {
				MCLoaded = true;
				var range = document.createRange();
				range.selectNode(document.head.lastChild);
				var f = range.createContextualFragment(MCHead);
				document.head.appendChild(f);
			}
		}
	}]);

	function MailchimpSignupForm(props) {
		_classCallCheck(this, MailchimpSignupForm);

		var _this = _possibleConstructorReturn(this, (MailchimpSignupForm.__proto__ || Object.getPrototypeOf(MailchimpSignupForm)).call(this, props));

		_this.submitted = _this.submitted.bind(_this);
		return _this;
	}

	_createClass(MailchimpSignupForm, [{
		key: 'submitted',
		value: function submitted() {
			this.close();
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _get2;

			MailchimpSignupForm.load();

			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}

			if (_get(MailchimpSignupForm.prototype.__proto__ || Object.getPrototypeOf(MailchimpSignupForm.prototype), 'componentDidMount', this)) (_get2 = _get(MailchimpSignupForm.prototype.__proto__ || Object.getPrototypeOf(MailchimpSignupForm.prototype), 'componentDidMount', this)).call.apply(_get2, [this].concat(args));
		}
	}, {
		key: 'content',
		get: function get() {
			return _react2.default.createElement(
				'div',
				{ id: 'mc_embed_signup' },
				_react2.default.createElement(
					'form',
					{ action: '//thepoolandspahouse.us3.list-manage.com/subscribe/post?u=bf0c242d34bdf1d8b7f8317fa&id=d07218bf8a', method: 'post',
						id: 'mc-embedded-subscribe-form',
						name: 'mc-embedded-subscribe-form',
						className: 'validate',
						target: '_blank',
						noValidate: true,
						onSubmit: this.submitted
					},
					_react2.default.createElement(
						'div',
						{ id: 'mc_embed_signup_scroll' },
						_react2.default.createElement(
							'div',
							{ className: 'indicates-required' },
							_react2.default.createElement(
								'span',
								{ className: 'asterisk' },
								'*'
							),
							' indicates required'
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-group mc-field-group' },
							_react2.default.createElement(
								'label',
								{ htmlFor: 'mce-EMAIL' },
								'Email Address ',
								_react2.default.createElement(
									'span',
									{ className: 'asterisk' },
									'*'
								)
							),
							_react2.default.createElement('input', { type: 'email', name: 'EMAIL', className: 'form-control required email', id: 'mce-EMAIL' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'mc-field-group form-group' },
							_react2.default.createElement(
								'label',
								{ htmlFor: 'mce-FNAME' },
								'First Name'
							),
							_react2.default.createElement('input', { type: 'text', name: 'FNAME', className: 'form-control', id: 'mce-FNAME' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'mc-field-group form-group' },
							_react2.default.createElement(
								'label',
								{ htmlFor: 'mce-LNAME' },
								'Last Name'
							),
							_react2.default.createElement('input', { type: 'text', name: 'LNAME', className: 'form-control', id: 'mce-LNAME' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'mc-field-group form-group' },
							_react2.default.createElement(
								'label',
								{ htmlFor: 'mce-MMERGE4' },
								'City ',
								_react2.default.createElement(
									'span',
									{ className: 'asterisk' },
									'*'
								)
							),
							_react2.default.createElement('input', { type: 'text', name: 'MMERGE4', className: 'form-control required', id: 'mce-MMERGE4' })
						),
						_react2.default.createElement(
							'div',
							{ id: 'mce-responses', className: 'clear' },
							_react2.default.createElement('div', { className: 'response', id: 'mce-error-response', style: { display: 'none' } }),
							_react2.default.createElement('div', { className: 'response', id: 'mce-success-response', style: { display: 'none' } })
						),
						null /* real people should not fill this in and expect good things - do not remove this or risk form bot signups */,
						_react2.default.createElement(
							'div',
							{ style: { position: 'absolute', left: '-5000px' }, 'aria-hidden': 'true' },
							_react2.default.createElement('input', { type: 'text', name: 'b_bf0c242d34bdf1d8b7f8317fa_d07218bf8a', tabIndex: '-1' })
						),
						_react2.default.createElement(
							'div',
							{ style: { textAlign: 'center' } },
							_react2.default.createElement(
								'button',
								{ className: 'btn btn-primary', type: 'submit', name: 'subscribe', value: 'Subscribe' },
								'Subscribe'
							)
						)
					)
				)
			);
		}
	}]);

	return MailchimpSignupForm;
}(_modal2.default);

exports.default = MailchimpSignupForm;
function show() {
	_modal2.default.showModal(_react2.default.createElement(MailchimpSignupForm, null));
}